import { render, staticRenderFns } from "./termlyModeList.vue?vue&type=template&id=20b7198d&scoped=true"
import script from "./termlyModeList.vue?vue&type=script&lang=js"
export * from "./termlyModeList.vue?vue&type=script&lang=js"
import style0 from "./termlyModeList.vue?vue&type=style&index=0&id=20b7198d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b7198d",
  null
  
)

export default component.exports